const omitEmptyProps = obj =>
    Object.keys(obj || {}).reduce((agg, key) => {
        const value = obj[key];
        if (value === undefined || value === null || value === '') {
            return agg;
        }

        return {
            ...agg,
            [key]: value,
        };
    }, {});

export { omitEmptyProps };



// WEBPACK FOOTER //
// ./source/services/helpers.js